import { graphql } from "relay-runtime"

export const chCreateProgressNoteMutation = graphql`
  mutation chCreateProgressNoteMutation($input: Ch_createProgressNoteInput!, $addConnections: [ID!]!) {
    createProgressNote: ch_createProgressNote(input: $input) {
      progressNoteMutationOutput: ch_ProgressNoteMutationOutput {
        progressNote @prependNode(connections: $addConnections, edgeTypeName: "ch_ProgressNoteEdge") {
          ...chProgressNoteFragment @relay(mask: false)
          ...chProgressNoteFragment
        }
        episodeOfCare {
          updatedAt
        }
      }
    }
  }
`
